import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphPersonaNudgeCoupon, fetchNudgeWisePerformance } from "./nudgeCouponAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  weeks: [],
  nudgeWisePerformance: {
    status: "idle",
    error: null,
    data: {},
    weeks: [],
  },
};

export const graphPersonaNudgeCoupon = createAsyncThunk(
  "nudgeCoupon/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-couponWise-personaPerformance`;
      const response = await fetchGraphPersonaNudgeCoupon(dbpath, user, "graph-couponWise-personaPerformance");
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const graphNudgeWisePerformance = createAsyncThunk(
  "nudgeCoupon/nudgeWisePerformance",
  async (user, { rejectWithValue }) => {
    try {
      console.log("Fetching nudge-wise performance data for user:", user);
      const dbpath = `${user}/graph-nudgeWise-personaPerformance`;
      const response = await fetchNudgeWisePerformance(dbpath, user, "graph-nudgeWise-personaPerformance");
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const nudgeCouponSlice = createSlice({
  name: "nudgeCoupon",
  initialState,
  reducers: {
    resetCouponWiseData: (state, action) => {
      return { ...initialState };
    }, 
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
    setNudgeIdName: (state, action) => { 
      state.nudgeKeyName = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphPersonaNudgeCoupon.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphPersonaNudgeCoupon.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.data = result[0];
          state.weeks = Object.keys(result[0]).reverse();

        } catch (error) {
          // console.warn("Persona data not found!", error)
        }

      })
      .addCase(graphPersonaNudgeCoupon.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      })
      .addCase(graphNudgeWisePerformance.pending, (state) => {
        state.nudgeWisePerformance.status = "loading";
      })
      .addCase(graphNudgeWisePerformance.fulfilled, (state, action) => {
        state.nudgeWisePerformance.status = "idle";
        state.nudgeWisePerformance.error = null;
        const { data, weeks } = action.payload;
        state.nudgeWisePerformance.data = data;
        state.nudgeWisePerformance.weeks = weeks;
      })
      .addCase(graphNudgeWisePerformance.rejected, (state, action) => {
        state.nudgeWisePerformance.status = "idle";
        state.nudgeWisePerformance.error = action.payload?.error;
      })
      .addMatcher(
        action => action.type === 'RESET_ALL',
        () => initialState  // Listens for the 'RESET_ALL' action and resets the state
      );
  },
});

export const {resetCouponWiseData, setNudgeIdName} = nudgeCouponSlice.actions;

export const SelectWeeks = (state) => state.nudgeCoupon.weeks;
export const SelectPersonaNudgeCouponStatus = (state) => state.nudgeCoupon.status;
export const selectNudgeWisePerformanceData = (state) => state.nudgeCoupon.nudgeWisePerformance.data;
export const selectNudgeWisePerformanceWeeks = (state) => state.nudgeCoupon.nudgeWisePerformance.weeks;
export const selectNudgeWisePerformanceStatus = (state) => state.nudgeCoupon.nudgeWisePerformance.status;
export const selectNudgeWisePerformanceError = (state) => state.nudgeCoupon.nudgeWisePerformance.error;


export default nudgeCouponSlice.reducer;
